module.exports = __webpack_public_path__ + "static/media/java.458aa802.png";